"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHiringProcessStages = getHiringProcessStages;
const axios_1 = require("./clients/axios");
async function getHiringProcessStages(offerId) {
    return (await axios_1.client.get('/0/hiring-process/stages', { params: { offerId } })).data;
}
